"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactNative = require("react-native");

var _Text = require("../Text");

var _Button = require("../Button/Button");

var _Util = require("../Util");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var styles = _reactNative.StyleSheet.create({
  container: {
    width: '100%',
    justifyContent: 'flex-end',
    height: 155,
    paddingHorizontal: 16,
    paddingBottom: 30
  },
  progressContainer: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    height: 36
  },
  progressInfosContainer: {
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  progressBarContainer: {
    width: '100%',
    height: 8,
    borderRadius: 12,
    backgroundColor: '#9DA79D'
  },
  progressBarContent: {
    backgroundColor: '#73C70C'
  },
  buttonsContainer: {
    marginTop: 10,
    width: '100%',
    height: 56,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  }
});

var styleInline = {
  button: {
    width: '48%',
    height: 55,
    fontSize: 20,
    textTransform: 'uppercase'
  }
};

var getPercentRound = function getPercentRound(_ref) {
  var activeIndex = _ref.activeIndex,
      exercicesLength = _ref.exercicesLength;
  return Math.round((activeIndex + 1) * 100 / exercicesLength) + "%";
};

var ProgressTracker = function ProgressTracker(_ref2) {
  var activeIndex = _ref2.activeIndex,
      exercicesLength = _ref2.exercicesLength;
  return /*#__PURE__*/_react["default"].createElement(_Text.Text, {
    color: "white",
    style: {
      fontSize: 18
    }
  }, activeIndex + 1, " / ", exercicesLength, " Exercices | ", getPercentRound({
    activeIndex: activeIndex,
    exercicesLength: exercicesLength
  }));
};

var ProgressBar = function ProgressBar(_ref3) {
  var activeIndex = _ref3.activeIndex,
      exercicesLength = _ref3.exercicesLength;
  return /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: [styles.progressBarContainer]
  }, /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: [styles.progressBarContainer, styles.progressBarContent, {
      width: getPercentRound({
        activeIndex: activeIndex,
        exercicesLength: exercicesLength
      })
    }]
  }));
};

var _default = function _default(_ref4) {
  var exercicesLength = _ref4.exercicesLength,
      activeIndex = _ref4.activeIndex,
      onPressPrev = _ref4.onPressPrev,
      onPressNext = _ref4.onPressNext,
      sessionTimer = _ref4.sessionTimer;
  return /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.container
  }, /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.progressContainer
  }, /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.progressInfosContainer
  }, /*#__PURE__*/_react["default"].createElement(ProgressTracker, {
    activeIndex: activeIndex,
    exercicesLength: exercicesLength
  }), /*#__PURE__*/_react["default"].createElement(_Text.Text, {
    style: {
      fontSize: 20,
      fontWeight: 'bold'
    },
    color: "white"
  }, (0, _Util.renderTime)(sessionTimer, 'short'))), /*#__PURE__*/_react["default"].createElement(ProgressBar, {
    activeIndex: activeIndex,
    exercicesLength: exercicesLength
  })), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.buttonsContainer
  }, /*#__PURE__*/_react["default"].createElement(_Button.Button, {
    style: styleInline.button,
    title: "Précédent",
    onPress: onPressPrev,
    color: "app-secondary"
  }), /*#__PURE__*/_react["default"].createElement(_Button.Button, {
    style: styleInline.button,
    title: activeIndex == exercicesLength - 1 ? "Fin" : "Suivant",
    onPress: onPressNext,
    color: "app-primary"
  })));
};

exports["default"] = _default;